// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery-menu {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 10px;
  border-radius: 10px;
  text-align: center;
  align-items: center;
  position: relative;
  width: 100%;
  justify-content: center;
}

.gallery-item-cover {
  position: relative;
  background-color: var(--orwi-menu-product-cover);
  opacity: 1;
  font-size: 13px;
  display: flex;
  width: 100%;
  margin-top: 2px;
  align-items: center;
  border-bottom: 1px solid rgba(225, 222, 222, 0.7490196078);
  margin-right: 5px;
  padding: 4px;
  padding-bottom: 15px;
  padding-top: 15px;
}

.gallery-gift-cover {
  position: relative;
  background-color: var(--orwi-menu-product-cover);
  opacity: 1;
  margin-bottom: 5px;
  font-size: 13px;
  display: flex;
  margin-top: 5px;
  align-items: center;
  border-bottom: 1px solid #ada2a2;
  margin-right: 5px;
  padding: 4px;
  background-color: #75d578;
  margin: 10px;
  padding: 5px;
  border-radius: 10px;
}

@media screen and (min-width: 768px) {
  .gallery-item-cover {
    width: 45vw;
    margin: 15px;
  }
}
.gallery-product-image {
  width: 120px;
  border-radius: 10px 10px 10px 10px !important;
}

.gallery-text-cover {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: left;
}

.gallery-price {
  font-size: 14px;
  font-weight: bold;
  color: var(--orwi-menu-product-price);
  margin-right: 10px;
}

.gallery-name {
  font-size: 14px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}

#description {
  font-size: 11px;
  text-align: left;
  margin-top: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-right: 5px;
  font-style: italic;
}

.search-results {
  height: 20rem;
  overflow: scroll;
}

.product-sold-out {
  opacity: 0.8;
}

.sold-out {
  position: absolute;
  z-index: 50;
  color: var(--orwi-menu-product-price);
  font-size: 30px;
  background-color: rgba(0, 0, 0, 0.5803921569);
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: var(--orwi-radius);
  color: white;
  bottom: 0px;
  font-size: 14px;
  height: 100%;
  font-weight: bold;
  font-family: "Inter";
  font-size: 24px;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

.ribbon {
  background: #d11508;
  display: inline-block;
  color: #f4f4f4;
  padding: 0.5em 0.7em;
  font-weight: 900;
  letter-spacing: 0.2em;
  position: relative;
  font-size: 1em;
  transform-style: preserve-3d;
  transform: rotate(350deg) skew(-20deg, 10deg);
}
.ribbon:before, .ribbon:after {
  content: "";
  width: 0;
  height: 2em;
  display: block;
  background: #d11508;
  position: absolute;
  border-style: solid;
  border-width: 0.5em;
  z-index: -1;
  transform: translateZ(-1em);
}
.ribbon:before {
  left: -0.5em;
  top: 0.5em;
  border-color: #870e05 #560903 #870e05 #870e05;
}
.ribbon:after {
  right: -0.5em;
  top: -0.5em;
  border-color: #870e05 #870e05 #870e05 #560903;
}

.high-light {
  color: red;
}

ion-img::part(image) {
  border-radius: 10px;
}

.cover {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  place-content: flex-start;
  padding-left: 2vw;
}

.group-title {
  background-color: #444242;
  z-index: 101;
  padding: 10px;
  font-size: 14px;
  font-weight: bolder;
  color: white;
  font-family: "Inter";
}

.sub-group-title {
  padding: 10px;
  background-color: #5a5858;
  z-index: 100;
  font-size: 12px;
  font-weight: bold;
  position: sticky;
  top: 0px;
  color: white;
  font-family: "Inter";
  padding-left: 20px;
}

#title-price {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 550;
  margin-right: 10px;
  font-family: "Inter";
}

.gallery-picture {
  margin-right: 10px;
}

.has-image {
  height: 75px;
  width: 120px;
}

#plus-icon {
  position: absolute;
  z-index: 99;
  background-color: #fffdfd;
  border-radius: 50%;
  font-size: 20px;
  height: 30px;
  width: 30px;
  opacity: 0.7;
  font-size: 30px;
}

#gift-title {
  text-align: center;
  font-family: "Inter";
  font-weight: bold;
  font-size: 18px;
}

.image-skeleton {
  width: 120px;
  height: 75px;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu/product-gallery-infinite/product-gallery-infinite.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gDAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,0DAAA;EACA,iBAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gDAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gCAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AACF;;AAEA;EACE;IACI,WAAA;IACA,YAAA;EACJ;AACF;AAEA;EACE,YAAA;EACA,6CAAA;AAAF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,sBAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,gBAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,qCAAA;EACA,eAAA;EACA,6CAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,iCAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;AADF;;AAWA;;;EAGE,sBAAA;AARF;;AAWA;EACE,mBAbO;EAcP,qBAAA;EACA,cAhBG;EAiBH,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAjBS;EAmBT,4BAAA;EACA,6CAAA;AATF;AAUE;EAEI,WAAA;EACA,QAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBA/BO;EAgCP,WAAA;EACA,2BAAA;AATN;AAWE;EACI,YAAA;EACA,UArCO;EAsCP,6CAAA;AATN;AAWE;EACI,aAAA;EACA,WAAA;EACA,6CAAA;AATN;;AAaA;EACE,UAAA;AAVF;;AAaA;EACE,mBAAA;AAVF;;AAaA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;AAVF;;AAaA;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EAGA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;AAZF;;AAeA;EACE,aAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,QAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;AAZF;;AAeA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AAZF;;AAeA;EACE,kBAAA;AAZF;;AAeA;EACE,YAAA;EACA,YAAA;AAZF;;AAeA;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAZF;;AAeA;EACE,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;AAZF;;AAqBA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AAlBF","sourcesContent":[".gallery-menu {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  border-radius: 10px;\n  text-align: center;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  justify-content: center;\n}\n\n.gallery-item-cover {\n  position: relative;\n  background-color: var(--orwi-menu-product-cover);\n  opacity: 1;\n  font-size: 13px;\n  display: flex;\n  width: 100%;\n  margin-top: 2px;\n  align-items: center;\n  border-bottom: 1px solid #e1dedebf;\n  margin-right: 5px;\n  padding: 4px;\n  padding-bottom: 15px;\n  padding-top: 15px;\n}\n\n.gallery-gift-cover {\n  position: relative;\n  background-color: var(--orwi-menu-product-cover);\n  opacity: 1;\n  margin-bottom: 5px;\n  font-size: 13px;\n  display: flex;\n  margin-top: 5px;\n  align-items: center;\n  border-bottom: 1px solid #ada2a2;\n  margin-right: 5px;\n  padding: 4px;\n  background-color: #75d578;\n  margin: 10px;\n  padding: 5px;\n  border-radius: 10px;\n}\n\n@media screen and (min-width: 768px) {\n  .gallery-item-cover {\n      width: 45vw;\n      margin: 15px;\n  }\n}\n\n.gallery-product-image {\n  width: 120px;\n  border-radius: 10px 10px 10px 10px !important;\n  //min-height: 250px;\n}\n\n.gallery-text-cover {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding-left: 5px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  text-align: left;\n}\n\n.gallery-price {\n  font-size: 14px;\n  font-weight: bold;\n  color: var(--orwi-menu-product-price);\n  margin-right: 10px;\n}\n\n.gallery-name {\n  font-size: 14px;\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#description {\n  font-size: 11px;\n  text-align: left;\n  margin-top: 5px;\n  display: -webkit-box;\n  -webkit-line-clamp: 10;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  margin-right: 5px;\n  font-style: italic;\n}\n\n.search-results {\n  height: 20rem;\n  overflow: scroll;\n}\n\n.product-sold-out {\n  opacity: 0.8;\n}\n\n.sold-out {\n  position: absolute;\n  z-index: 50;\n  color: var(--orwi-menu-product-price);\n  font-size: 30px;\n  background-color: #00000094;\n  display: flex;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  border-radius: var(--orwi-radius);\n  color: white;\n  bottom: 0px;\n  font-size: 14px;\n  height: 100%;\n  font-weight: bold;\n  font-family: \"Inter\";\n  font-size: 24px;\n}\n\n$bg: #f4f4f4;\n$ribbon: #d11508;\n$tail: darken($ribbon, 15%);\n$ribbonSize: 0.5em;\n$fontSize: 1em;\n$font: \"Roboto\",\nsans-serif;\n*,\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n.ribbon {\n  background: $ribbon;\n  display: inline-block;\n  color: $bg;\n  padding: $ribbonSize 0.7em;\n  font-weight: 900;\n  letter-spacing: 0.2em;\n  position: relative;\n  font-size: $fontSize;\n  //text-transform: uppercase;\n  transform-style: preserve-3d;\n  transform: rotate(350deg) skew(-20deg, 10deg);\n  &:before,\n  &:after {\n      content: \"\";\n      width: 0;\n      height: 2em;\n      display: block;\n      background: #d11508;\n      position: absolute;\n      border-style: solid;\n      border-width: $ribbonSize;\n      z-index: -1; // only necessary for flat (transform-style)\n      transform: translateZ(-1em); // orders the ribbon tails\n  }\n  &:before {\n      left: $ribbonSize * -1;\n      top: $ribbonSize;\n      border-color: $tail darken($tail, 10%) $tail $tail;\n  }\n  &:after {\n      right: $ribbonSize * -1;\n      top: $ribbonSize * -1;\n      border-color: $tail $tail $tail darken($tail, 10%);\n  }\n}\n\n.high-light {\n  color: red;\n}\n\nion-img::part(image) {\n  border-radius: 10px;\n}\n\n.cover {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  place-content: flex-start;\n  padding-left: 2vw;\n}\n\n.group-title {\n  background-color: #444242;\n  z-index: 101;\n  padding: 10px;\n  //position: sticky;\n  //top: 0px;\n  font-size: 14px;\n  font-weight: bolder;\n  color: white;\n  font-family: \"Inter\";\n}\n\n.sub-group-title {\n  padding: 10px;\n  background-color: #5a5858;\n  z-index: 100;\n  font-size: 12px;\n  font-weight: bold;\n  position: sticky;\n  top: 0px;\n  color: white;\n  font-family: \"Inter\";\n  padding-left: 20px;\n}\n\n#title-price {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  font-weight: 550;\n  margin-right: 10px;\n  font-family: \"Inter\";\n}\n\n.gallery-picture {\n  margin-right: 10px;\n}\n\n.has-image {\n  height: 75px;\n  width: 120px;\n}\n\n#plus-icon {\n  position: absolute;\n  z-index: 99;\n  background-color: #fffdfd;\n  border-radius: 50%;\n  font-size: 20px;\n  height: 30px;\n  width: 30px;\n  opacity: 0.7;\n  font-size: 30px;\n}\n\n#gift-title {\n  text-align: center;\n  font-family: \"Inter\";\n  font-weight: bold;\n  font-size: 18px;\n  // position: sticky;\n  // top: 0px;\n  // background-color: var(--background);\n  // height: 100%;\n  // z-index: 1000;\n  // border-bottom: 1px solid gray;\n}\n\n.image-skeleton {\n  width: 120px;\n  height: 75px;\n  border-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
